import { useState } from "react";
import logo from "../assets/images/newLogoNoBg.png";

import { NavLink, useLocation } from "react-router-dom";
import { AppBar } from "@mui/material";
import Box from "@mui/material/Box";
import Toolbar from "@mui/material/Toolbar";
import IconButton from "@mui/material/IconButton";
import Typography from "@mui/material/Typography";
import Menu from "@mui/material/Menu";
import MenuIcon from "@mui/icons-material/Menu";
import Container from "@mui/material/Container";
import MenuItem from "@mui/material/MenuItem";

const pages = [
  { url: "/", label: "Home" },
  { url: "/#prenota", label: "Prenota una lezione", isHash: true },
  { url: "/#chi-sono", label: "Chi sono", isHash: true },
  { url: "/#percorsi", label: "Esplora i percorsi", isHash: true },
  { url: "/#prezzi", label: "Prezzi e abbonamenti", isHash: true },
  { url: "/blog", label: "Blog" },
];

function Header() {
  const [anchorElNav, setAnchorElNav] = useState(null);
  const location = useLocation();

  // Filtra le pagine se siamo nella pagina prenotazioni
  const visiblePages = location.pathname === "/prenotazioni" ? pages.filter((page) => page.url === "/") : pages;

  const handleOpenNavMenu = (event) => {
    setAnchorElNav(event.currentTarget);
  };

  const handleCloseNavMenu = () => {
    setAnchorElNav(null);
  };

  const handleNavClick = (url, isHash) => {
    handleCloseNavMenu();
    if (isHash) {
      const element = document.querySelector(url.replace("/#", "#"));
      if (element) {
        element.scrollIntoView({ behavior: "smooth" });
      }
    }
  };

  return (
    <AppBar
      position="fixed"
      color="secondary"
      component={"nav"}
      elevation={0}
      sx={{
        borderBottom: "1.5px solid",
        borderColor: "primary.main",
        bgcolor: "secondary.main",
      }}
    >
      <Container maxWidth="xl">
        <Toolbar sx={{ padding: "10px" }}>
          {/* Logo mobile */}
          <Box sx={{ display: { xs: "block", md: "none" } }}>
            <NavLink to="/" aria-label="Home">
              <Box component="img" src={logo} alt="Logo" className="logo" sx={{ mr: 2 }} />
            </NavLink>
          </Box>

          {/* Logo + titolo desktop */}
          <Box
            sx={{
              display: { xs: "none", md: "flex" },
              flexGrow: 1,
              alignItems: "center",
            }}
          >
            <NavLink to="/" aria-label="Home">
              <Box component="img" src={logo} alt="Logo" className="logo" sx={{ mr: 2 }} />
            </NavLink>
            <Typography
              variant="h4"
              noWrap
              color="primary"
              sx={{
                mr: 2,
                fontWeight: 700,
                letterSpacing: ".3rem",
                textDecoration: "none",
              }}
            >
              Ilaria Stumpo
            </Typography>
          </Box>

          {/* Titolo mobile */}
          <Box
            sx={{
              flexGrow: 1,
              display: { xs: "flex", md: "none" },
              justifyContent: "center",
            }}
          >
            <Typography
              noWrap
              variant="h5"
              color="primary"
              sx={{
                mr: 2,
                fontWeight: 700,
                letterSpacing: ".3rem",
                textDecoration: "none",
              }}
            >
              Ilaria Stumpo
            </Typography>
          </Box>

          {/* Hamburger Menu mobile */}
          <Box sx={{ display: { xs: "block", md: "none" } }}>
            <IconButton size="large" aria-label="Apri menu di navigazione" aria-controls="menu-appbar" aria-haspopup="true" onClick={handleOpenNavMenu} color="primary">
              <MenuIcon fontSize="20px" />
            </IconButton>
            <Menu id="menu-appbar" anchorEl={anchorElNav} anchorOrigin={{ vertical: "bottom", horizontal: "left" }} keepMounted transformOrigin={{ vertical: "top", horizontal: "left" }} open={Boolean(anchorElNav)} onClose={handleCloseNavMenu} sx={{ display: { xs: "block", md: "none" } }}>
              {visiblePages.map((page, index) => (
                <MenuItem key={page.url + index} onClick={() => handleNavClick(page.url, page.isHash)} sx={{ justifyContent: "center" }}>
                  {page.isHash ? (
                    <a
                      href={page.url}
                      className="header-link"
                      style={{
                        width: "100%",
                        textAlign: "center",
                        display: "block",
                      }}
                    >
                      {page.label}
                    </a>
                  ) : (
                    <NavLink
                      to={page.url}
                      className={({ isActive }) => (isActive ? "header-link active" : "header-link")}
                      style={{
                        width: "100%",
                        textAlign: "center",
                        display: "block",
                      }}
                    >
                      {page.label}
                    </NavLink>
                  )}
                </MenuItem>
              ))}
            </Menu>
          </Box>

          {/* Menu desktop */}
          <Box className="header-nav" sx={{ display: { xs: "none", md: "flex" } }}>
            {visiblePages.map((page, index) =>
              page.isHash ? (
                <a href={page.url} key={index} className="header-link">
                  {page.label}
                </a>
              ) : (
                <NavLink to={page.url} key={index} className={({ isActive }) => (isActive ? "header-link active" : "header-link")}>
                  {page.label}
                </NavLink>
              ),
            )}
          </Box>
        </Toolbar>
      </Container>
    </AppBar>
  );
}

export default Header;
